module.exports = __webpack_public_path__ + "static/media/r5.09bf1589.jpg";